import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import useWindowSize from '@components/common/hooks/useWindowSize';
import { M_DEVICE } from '@components/lpc/Constants';

import Card from './Card/Card';
import css from './Pools.module.scss';

const Pools = () => {
    const { t } = useTranslateLpc('lpc-solidarity-page');
    const { width } = useWindowSize();
    const isPair = (nbr) => {
        return nbr % 2 == 0;
    };
    return (
        <div className={css.pools_container}>
            {width > M_DEVICE ? (
                <>
                    <div className={css.pools_container__column}>
                        {Array.from({ length: parseInt(t('pool_creation.actions.size')) }, (_, poolIndex) =>
                            !isPair(poolIndex) ? <Card key={poolIndex} poolIndex={poolIndex} /> : null,
                        )}
                    </div>
                    <div className={css.pools_container__column}>
                        {Array.from({ length: parseInt(t('pool_creation.actions.size')) }, (_, poolIndex) =>
                            isPair(poolIndex) ? <Card key={poolIndex} poolIndex={poolIndex} /> : null,
                        )}
                    </div>
                </>
            ) : (
                <div className={css.pools_container__grid_container}>
                    {Array.from({ length: parseInt(t('pool_creation.actions.size')) }, (_, poolIndex) => (
                        <Card key={poolIndex} poolIndex={poolIndex} />
                    ))}
                </div>
            )}
        </div>
    );
};
export default Pools;
